import {
  ChangeDetectionStrategy,
  Component,
  input,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

// services
import { BookPathwaysPlansInputFacade } from '../../services/pathways-and-plans/book-pathways-and-plans.facade';

// misc
import { InputContext } from '@app/user-content/user-input/user-input.model';
import { LineClampDirective } from '@app/shared/directives/line-clamp/line-clamp.directive';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from '@app/shared/components/modal/modal.module';
import { ValidateFieldComponent } from '@app/shared/components/validate-field/validate-field.component';
import { TagsEditComponent } from '@app/tags/components/tags-edit/tags-edit.component';
import { ReactiveFormsLabelComponent } from '@app/shared/components/reactive-forms-label/reactive-forms-label.component';
import { PathwayStep } from '@dg/pathways-rsm';
import { AutofocusDirective } from '@app/shared/directives/autofocus.directive';
import { ViewModel } from '../../book.model';

@Component({
  selector: 'dgx-book-pathways-and-plans',
  imports: [
    CommonModule,
    AsyncPipe,
    ReactiveFormsModule,
    FormsModule,
    LineClampDirective,
    NgbTypeaheadModule,
    ModalModule,
    ValidateFieldComponent,
    TagsEditComponent,
    ReactiveFormsLabelComponent,
    AutofocusDirective,
  ],
  templateUrl: './book-pathways-and-plans.component.html',
  styleUrl: './book-pathways-and-plans.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [BookPathwaysPlansInputFacade],
})
export class BookPathwaysAndPlansComponent {
  readonly context = input<InputContext>();
  public pathwayStep = input<PathwayStep>();

  public vm$: Observable<ViewModel>;
  private facade = inject(BookPathwaysPlansInputFacade);

  /**
   * TODO: Currently for local edit there are properties that we can not edit(PD-95879),
   * and for book there are no properties that we can edit so Editing in a pathway/plan
   * is hidden.
   */

  public ngOnInit(): void {
    this.vm$ = this.facade.initializeViewModel(
      this.context(),
      this.pathwayStep()
    );
  }
}
